import { Spinner } from "@fluentui/react";
import {
  Button,
  Divider,
  Input,
  Label,
  makeStyles,
  shorthands,
  Dropdown,
  Option
} from "@fluentui/react-components";
import {
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  DrawerOverlay,
} from "@fluentui/react-components/unstable";
import {
  Dismiss24Regular
} from "@fluentui/react-icons";
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import axios from "axios";
import { Timestamp } from "firebase/firestore";
import qs from "qs";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Controller, useForm } from "react-hook-form";
import { Base_Url, auth, trackException } from "../../services/firebase";
import UserDataService from "../../services/userDataService";
import { BankCardSVG, BankDeleteSVG, BankSVG } from "../../static/svgs";
import DeleteEventDialog from "../DeleteEventDialog";
import SubsriptionListActive from "../SubsriptionListActive";
import ConfirmationDialog from "../ConfirmationDialog";

export const InitialWalletState = {
  memberships: [],
};

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    // Use 2px gap below the label (per the design system)
    ...shorthands.gap("2px"),
  },
  control: {
    maxWidth: "300px",
  },
});

function UserWalletForm(props) {
  const styles = useStyles();
  const { handleSubmit, control, reset, setValue, formState: { isDirty, dirtyFields }, } = useForm({
    defaultValues: props.selectedUser ? props.selectedUser : InitialWalletState,
  });
  const stripe = useStripe();
  const elements = useElements();

  const [stripeCustomerId, setStripeCustomerId] = useState(null);
  const [cardList, setCardList] = useState([]);
  // Card-type PaymentMethods (pm_) — cards added after the PaymentMethods
  // migration live here; legacy card Sources remain in cardList. Rendered merged.
  const [paymentMethodCards, setPaymentMethodCards] = useState([]);
  const [subscriptionList, setSubscriptionList] = useState([]);
  const [creditPackageList, setCreditPackageList] = useState([]);
  const [activeSubscriptionList, setActiveSubscriptionList] = useState([]);
  const [selectedMemberships, setSelectedMemberships] = useState([]);
  const [selectedCreditPackage, setSelectedCreditPackage] = useState([]);

  const [seletedCardObj, setSeletedCardObj] = useState(null);
  const [seletedBankObj, setSeletedBankObj] = useState(null);
  const [isDeleteOpen, setIsDeleteOpen] = React.useState(false);
  const [isDeleteBankOpen, setIsDeleteBankOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoadingAddCredit, setIsLoadingAddCredit] = React.useState(false);
  const [isLoadingAddMembership, setIsLoadingAddMembership] = React.useState(false);
  const [isSubscriptionLoading, setIsSubscriptionLoading] = React.useState(false);

  const [isBalanceLoader, setBalanceLoader] = React.useState(false);
  const [user, loading, error] = useAuthState(auth);
  const [bankAccount, setBankAccount] = useState(null);
  const [accountName, setAccountName] = useState(null);
  const [accountNumber, setAccountNumber] = useState(null);
  const [routingNumber, setRoutingNumber] = useState(null);
  const [newbalance, setNewbalance] = useState(0);
  const [balanceDesc, setBalanceDesc] = useState('');
  const [drivingFleetBal, setDrivingFleetBal] = useState(0);

  const [selectedMembershipPlaceholder, setSeletedMembershipPlaceholder] = useState("");
  const [accountHolderData, setAccountHolderData] = useState(null);
  const [currentUserData, setCurrentUserData] = useState(null);
  const [memberHasParent, setMemberHasParent] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [selectedSub, setSelectedSub] = useState(null);

  const onSubmit = async (formdata) => {
    var data = props.selectedUser;
    data.memberships = formdata.memberships;
    var id = "";
    if (props.selectedUser) {
      id = props.selectedUser.id;
      await UserDataService.updateUser(props.selectedUser.id, data);
    } else {
    }
    props.setIsOpen(false);
    props.updateGrid();
  };

  async function updateCustomerIdInFir(customerId) {
    if (memberHasParent) { return }
    await UserDataService.updateUser(props.selectedUser.id, {
      stripeCustomerId: customerId,
    });
  }

  async function onAddBalanceClick() {
    if (newbalance && parseInt(newbalance) > 0) {
      let mainUserId = getParentAccountId()
      setBalanceLoader(true)
      try {
        const userDoc = await UserDataService.getUser(mainUserId);
        let userDocObj = userDoc.data();
        if (userDocObj) {
          let totalAmount = 0
          if (userDocObj.totalAmount && parseInt(userDocObj.totalAmount) > 0) {
            totalAmount = parseFloat(userDocObj.totalAmount) + parseFloat(newbalance)
          } else {
            totalAmount = parseFloat(newbalance)
          }
          await UserDataService.updateUser(mainUserId, {
            totalAmount: totalAmount,
          });
          let data = {
            "type": "Admin_Gift",
            "refId": "",
            "creditType": "Credit",
            "amount": newbalance,
            "userId": mainUserId,
            "currentUserId": props.selectedUser.id,
            "createdBy": user.uid,
            "isDrivingFeet": false,
            "createdAt": Timestamp.now(),
            "desription": balanceDesc || ''
          };
          const addeddata = await UserDataService.addTransaction(data);
          setNewbalance(0)
          alert("Balance Add successfully.")
          setBalanceLoader(false)
          props.setIsOpen(false);
          props.updateGrid();
        }
      } catch (error) {
        setBalanceLoader(false)
        console.log("error->", error)
      }
    }
  }

  async function onSubtractBalanceClick() {
    if (newbalance && parseInt(newbalance) > 0) {
      setBalanceLoader(true)
      let mainUserId = getParentAccountId()
      try {
        const userDoc = await UserDataService.getUser(mainUserId);
        let userDocObj = userDoc.data();
        if (userDocObj) {
          let totalAmount = 0
          if (userDocObj.totalAmount && parseInt(userDocObj.totalAmount) > 0) {
            totalAmount = parseFloat(userDocObj.totalAmount) - parseFloat(newbalance)
            if (totalAmount >= 0) {
              await UserDataService.updateUser(mainUserId, {
                totalAmount: totalAmount,
              });
              let data = {
                "type": "Subtract_By_Admin",
                "refId": "",
                "creditType": "Debit",
                "amount": newbalance,
                "userId": mainUserId,
                "currentUserId": props.selectedUser.id,
                "createdBy": user.uid,
                "isDrivingFeet": false,
                "createdAt": Timestamp.now(),
                "desription": balanceDesc || ''
              };
              const addeddata = await UserDataService.addTransaction(data);
              setNewbalance(0)
              alert("Balance Subtract successfully.")
              setBalanceLoader(false)
              props.setIsOpen(false);
              props.updateGrid();
            } else {
              setBalanceLoader(false)
              alert("Insufficient balance in user wallet.");
            }
          } else {
            setBalanceLoader(false)
            alert("Insufficient balance in user wallet.");
          }
        }
      } catch (error) {
        setBalanceLoader(false)
        alert(error);
        console.log("error->", error)
      }
    }
  }

  async function onAddDrivingFleetBalanceClick() {
    if (drivingFleetBal && parseInt(drivingFleetBal) > 0) {
      setBalanceLoader(true)
      try {
        let mainUserId = getParentAccountId()
        const userDoc = await UserDataService.getUser(mainUserId);
        let userDocObj = userDoc.data();
        if (userDocObj) {
          let drivingFleetBalPoint = getPointFromUSD(drivingFleetBal)
          let aTotalPoint = 0
          if (userDocObj.totalPoint && parseInt(userDocObj.totalPoint) > 0) {
            aTotalPoint = parseFloat(userDocObj.totalPoint) + drivingFleetBalPoint
          } else {
            aTotalPoint = drivingFleetBalPoint
          }
          await UserDataService.updateUser(mainUserId, {
            totalPoint: aTotalPoint,
          });
          let data = {
            "type": "Admin_DrivingFleet_Gift",
            "refId": "",
            "creditType": "Credit",
            "points": drivingFleetBalPoint,
            "userId": mainUserId,
            "currentUserId": props.selectedUser.id,
            "createdBy": user.uid,
            "isDrivingFeet": true,
            "createdAt": Timestamp.now(),
          };
          const addeddata = await UserDataService.addTransaction(data);
          setNewbalance(0)
          alert("Balance Add successfully.")
          setBalanceLoader(false)
          props.setIsOpen(false);
          props.updateGrid();
        }
      } catch (error) {
        setBalanceLoader(false)
        console.log("error->", error)
      }
    }
  }

  async function onSubtractDrivingFleetBalanceClick() {
    if (drivingFleetBal && parseInt(drivingFleetBal) > 0) {
      setBalanceLoader(true)
      try {
        let mainUserId = getParentAccountId()
        const userDoc = await UserDataService.getUser(mainUserId);
        let userDocObj = userDoc.data();
        if (userDocObj) {
          let drivingFleetBalPoint = getPointFromUSD(drivingFleetBal)
          let aTotalPoint = 0
          if (userDocObj.totalPoint && parseInt(userDocObj.totalPoint) > 0) {
            aTotalPoint = parseFloat(userDocObj.totalPoint) - drivingFleetBalPoint
          }
          await UserDataService.updateUser(mainUserId, {
            totalPoint: aTotalPoint,
          });
          let data = {
            "type": "Admin_Debit_DrivingFleet",
            "refId": "",
            "creditType": "Debit",
            "points": drivingFleetBalPoint,
            "amount": drivingFleetBal,
            "userId": mainUserId,
            "currentUserId": props.selectedUser.id,
            "createdBy": user.uid,
            "isDrivingFeet": true,
            "createdAt": Timestamp.now(),
          };
          const addeddata = await UserDataService.addTransaction(data);
          setNewbalance(0)
          alert("Balance Subtract successfully.")
          setBalanceLoader(false)
          props.setIsOpen(false);
          props.updateGrid();
        }
      } catch (error) {
        setBalanceLoader(false)
        console.log("error->", error)
      }
    }
  }

  async function getCardToken() {
    if (memberHasParent) {
      return;
    }
    if (stripeCustomerId) {
      try {
        // Stripe is null when REACT_APP_STRIPE_PUBLISHABLE_KEY is missing from
        // the build (see Layout.js). Say so, rather than throwing on null.
        if (!stripe || !elements) {
          alert("Card entry is unavailable: Stripe is not configured for this environment. Please report this to the development team.");
          trackException("getCardToken: Stripe not initialised - REACT_APP_STRIPE_PUBLISHABLE_KEY missing");
          return;
        }
        const cardElement = elements.getElement("card");
        const res = await stripe.createToken(cardElement);
        // createToken resolves with { error } on failure - token is undefined,
        // so the old `res.token.card` threw a TypeError and the catch alerted
        // an unreadable object instead of Stripe's actual message. That is how
        // the expired/wrong-mode key problem presented to staff: an opaque
        // popup rather than "Expired API Key provided".
        if (res && res.error) {
          alert(res.error.message || "The card could not be verified. Please check the details and try again.");
          trackException(JSON.stringify(res.error));
          return;
        }
        if (res && res.token && res.token.card) {
          cardElement.clear();
          addCartOnFile(res.token.id);
        }
      } catch (error) {
        alert((error && error.message) || error);
        trackException(JSON.stringify(error))
      }
    }
  }

  const getStripeSubscriptionList = async () => {
    let config = {
      method: "get",
      url: `${Base_Url}/stripeApi/getSubscriptionProducts`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
    };
    setIsSubscriptionLoading(true)
    axios
      .request(config)
      .then((response) => {
        setIsSubscriptionLoading(false)
        if (response && response.data && response.data.data) {

          let creditPackages = response?.data?.data?.filter((data) => (data?.metadata?.SubCategory == "Addon" || data?.metadata?.SubCategory == "AddonSubscription"))

          if (creditPackages && creditPackages.length > 0) {
            const sortedProducts = creditPackages.sort((a, b) => a.amount - b.amount);
            setCreditPackageList(sortedProducts)
          }

          let subsList = response?.data?.data?.filter((data) => (data?.metadata?.SubCategory == "Membership"))
          setSubscriptionList(subsList);
        }
      })
      .catch((error) => {
        setIsSubscriptionLoading(false)
        console.log(error);
      });
  };

  async function generateBankToken() {
    if (memberHasParent) {
      return
    }
    if (
      accountName &&
      accountName.trim() != "" &&
      routingNumber &&
      routingNumber.trim() != "" &&
      accountNumber &&
      accountNumber != ""
    ) {
      // (Removed: dead commented-out code that called api.stripe.com directly
      // with process.env.REACT_APP_STRIPE_SK_KEY. Tokenization goes through the
      // backend below — a Stripe secret key must never reach the browser.)

    let data = JSON.stringify({
        "country": "US",
        "currency": "usd",
        "accountHolderName": accountName,
        "bank_account[account_holder_type]": "individual",
        "routingNumber": routingNumber ?? "110000000",
        "accountNumber": accountNumber ?? "000123456789",
      });
    let config = {
      method: 'post',
      url: `${Base_Url}/stripeApi/generateBankToken`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${user.accessToken}`,
      },
      data: data
    };
    axios.request(config)
      .then((response) => {
        if (response && response.data != "") {
          if (response.data && response.data.bankAccountToken && response.data.bankAccountToken.id) {
            addBankOnFile(response.data.bankAccountToken.id);
          }
        }
      })
      .catch((error) => {
        alert(error)
        trackException(JSON.stringify(error))
      });
    }
    
  }

  async function getStripCustomerId() {
    if (props.selectedUser && props.selectedUser.email) {
      setIsLoading(true);
      let config = {
        method: "get",
        url: `${Base_Url}/stripeApi/searchStripeUserByEmail?email=${props.selectedUser.email}`,
        headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
      };
      axios
        .request(config)
        .then((response) => {
          if (response && response.data && (response?.data?.customers?.data ?? []).length > 0) {
            let customer = response.data.customers.data[0];
            if (customer && customer.id) {
              setStripeCustomerId(customer.id);
              getCardListByCustomerId(customer.id);
              getPaymentMethodByCustomerId(customer.id);
              updateCustomerIdInFir(customer.id);
              getStripeSubscriptionByCustomer(customer.id)
            } else {
              //Create Customer Id in stripe
              console.log("No Customer...")
              createStripeCustomer()
            }
          } else {
            // No existing Stripe customer for this member — create one so a card
            // can be added. Previously this branch just left stripeCustomerId null,
            // so Add Card silently no-opped for every brand-new member.
            createStripeCustomer();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          setStripeCustomerId(null);
        });
    }
  }
  async function createStripeCustomer() {
    let data = JSON.stringify({
      "name": `${props.selectedUser.firstName}`,
      "description": "Warehouse",
      "email": `${props.selectedUser.email}`
    });
    let config = {
      method: 'post',
      url: `${Base_Url}/stripeApi/createStripeCustomer`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
      data: data
    };
    axios.request(config)
      .then((response) => {
        if (response && response.data != "") {
          if (response.data && response.data.data && response.data.data.id) {
            let customer = response.data.data
            if (customer && customer.id) {
              setStripeCustomerId(customer.id);
              getCardListByCustomerId(customer.id);
              getPaymentMethodByCustomerId(customer.id);
              updateCustomerIdInFir(customer.id);
            }
          } else {
          }
        }
      })
      .catch((error) => {
        console.log(error);
        alert(error)
        trackException(JSON.stringify(error))
      });
  }

  async function getStripeSubscriptionByCustomer(stripeCustomerId) {
    if (props.selectedUser) {
      let config = {
        method: "get",
        url: `${Base_Url}/stripeApi/getStripeSubscriptionByCustomerId`,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.accessToken}`,
        },
        params: {
          customerId: stripeCustomerId
        }
      };
      axios
        .request(config)
        .then((response) => {
          if (response && response.data) {
            let activeSubsriptionArr = response.data.data
            setActiveSubscriptionList(activeSubsriptionArr)
            let activeProductIds = activeSubsriptionArr.map(activeSub => activeSub.productId);

            let inactiveSubscriptions = subscriptionList.filter(subscription => !activeProductIds.includes(subscription.id));
            setSubscriptionList(inactiveSubscriptions)

            let inactiveCreditPackageList = creditPackageList.filter(subscription => !activeProductIds.includes(subscription.id));
            if (inactiveCreditPackageList && inactiveCreditPackageList.length > 0) {
              const sortedProducts = inactiveCreditPackageList.sort((a, b) => a.amount - b.amount);
              setCreditPackageList(sortedProducts)
            }

          } else {
            setActiveSubscriptionList([])
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setIsLoading(false);
          trackException(JSON.stringify(error))
        });
    }
  }

  async function getCardListByCustomerId(stripeCustomerId) {
    if (props.selectedUser) {
      let config = {
        method: "get",
        url: `${Base_Url}/stripeApi/getStripeCardsList?stripeCustomerId=${stripeCustomerId}`,
        headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
      };
      axios
        .request(config)
        .then((response) => {
          if (response && response.data && (response?.data?.cards?.data ?? []).length > 0) {
            setCardList(response?.data?.cards?.data ?? []);
          } else {
            setCardList([]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setCardList([]);
          setIsLoading(false);
          trackException(JSON.stringify(error))
        });
    }
  }


  async function getBankByCustomerId(stripeCustomerId) {
    //TODO: Set dynamic email address
    if (props.selectedUser) {
      let config = {
        method: "get",
        url: `${Base_Url}/stripeApi/getAllStripeBankAccountsList?customerId=${stripeCustomerId}`,
        headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
      };
      axios
        .request(config)
        .then((response) => {
          if (response && response.data) {
            setBankAccount(response.data.data ?? response.data.sources.data ?? []);
          } else {
            setBankAccount(null);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setBankAccount(null);
          setIsLoading(false);
        });
    }
  }

  async function getPaymentMethodByCustomerId(stripeCustomerId) {
    //TODO: Set dynamic email address
    if (props.selectedUser) {
      let config = {
        method: "get",
        url: `${Base_Url}/stripeApi/getListPaymentMethods?customerId=${stripeCustomerId}`,
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${user.accessToken}`,
        }
      };
      axios
        .request(config)
        .then((response) => {
          if (response && response.data) {
            const resArr = response.data.data;
            let bankList = resArr
              .filter((data) => data.type === "bank_account")
              .map((data) => ({
                id: data.id,
                last4: data.bank_account.last4,
                bank_name: data.bank_account.bank_name,
              }));
            let bankList2 = resArr
              .filter((data) => data.type === "us_bank_account")
              .map((data) => ({
                id: data.id,
                last4: data.us_bank_account.last4,
                bank_name: data.us_bank_account.bank_name,
              }));
            setBankAccount([...bankList, ...bankList2]);
            // Surface card-type PaymentMethods (added post-migration) so they
            // show in the Card list alongside any legacy card Sources.
            const cardPMs = resArr
              .filter((data) => data.type === "card" && data.card)
              .map((data) => ({
                id: data.id,
                last4: data.card.last4,
                brand: data.card.brand,
              }));
            setPaymentMethodCards(cardPMs);
          } else {
            setBankAccount(null);
            setPaymentMethodCards([]);
          }
          setIsLoading(false);
        })
        .catch((error) => {
          setBankAccount(null);
          setPaymentMethodCards([]);
          setIsLoading(false);
        });
    }
  }

  async function addCartOnFile(cardToken) {
    let data = JSON.stringify({
      customerId: stripeCustomerId,
      cardToken: cardToken,
    });
    let config = {
      method: "post",
      url: `${Base_Url}/stripeApi/addStripeCard`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
      data: data,
    };
    axios
      .request(config)
      .then((response) => {
        if (response && response.data) {
          getCardListByCustomerId(stripeCustomerId);
          // New cards are PaymentMethods now, so refresh that list too.
          getPaymentMethodByCustomerId(stripeCustomerId);
        }
      })
      .catch((error) => {
        alert(error?.response?.data?.error || error || 'Something went wrong!');
      });
  }

  async function addBankOnFile(bankToken) {
    if (memberHasParent) {
      return
    }
    let data = JSON.stringify({
      customerId: stripeCustomerId,
      bankToken: bankToken,
    });
    let config = {
      method: "post",
      url: `${Base_Url}/stripeApi/addStripeBankAccount`,
      //url: `https://1df4-2405-201-1012-c14b-1448-8f43-b8bb-85bb.ngrok-free.app`,
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${user.accessToken}`,
      },
      data: data,
    };
    axios
      .request(config)
      .then((response) => {
        if (response && response.data) {
          getBankByCustomerId(stripeCustomerId);
        }
      })
      .catch((error) => {
        alert(error);
      });
  }

  async function deleteCard(cardId) {
    if (memberHasParent) {
      return;
    }
    let config = {
      method: "delete",
      url: `${Base_Url}/stripeApi/deleteStripeCard?customerId=${stripeCustomerId}&cardId=${cardId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
    };
    axios
      .request(config)
      .then((response) => {
        if (response && response.data) {
          getCardListByCustomerId(stripeCustomerId);
        }
      })
      .catch((error) => {
        alert(error);
      });
    setIsDeleteOpen(false);
  }

  async function deleteBankAccount(accountId) {
    let config = {
      method: "delete",
      url: `${Base_Url}/stripeApi/deleteStripeBankAccount?customerId=${stripeCustomerId}&bankAccountId=${accountId}`,
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${user.accessToken}`,
      },
    };
    axios
      .request(config)
      .then((response) => {
        if (response && response.data) {
          getBankByCustomerId(stripeCustomerId);
        }
      })
      .catch((error) => {
        alert(error);
      });
    setIsDeleteBankOpen(false);
  }

  async function checkUserHasParent(userdata) {
    if (userdata && userdata.accountHolderId && userdata.accountHolderId != "" && userdata.accountHolderId != userdata.id) {
      try {
        const userDoc = await UserDataService.getUser(userdata.accountHolderId);
        let parentuser = userDoc.data();
        if (parentuser) {
          setMemberHasParent(true)
          setAccountHolderData(parentuser)
          setStripeData(parentuser)
        } else {
          setAccountHolderData(null)
          setStripeData(userdata)
        }
      } catch (error) {
        setMemberHasParent(false)
        setStripeData(userdata)
      }
    } else {
      setAccountHolderData(null)
      setMemberHasParent(false)
      setStripeData(userdata)
    }
  }

  async function setStripeData(userDocObj) {
    //TODO: check customer id exist in Firestore
    if (userDocObj && userDocObj.stripeCustomerId && userDocObj.stripeCustomerId != "") {
      setStripeCustomerId(userDocObj.stripeCustomerId);
      getCardListByCustomerId(userDocObj.stripeCustomerId);
      getPaymentMethodByCustomerId(userDocObj.stripeCustomerId);
      getStripeSubscriptionByCustomer(userDocObj.stripeCustomerId)
    } else {
      getStripCustomerId();
    }
  }

  async function getUserDetails() {
    if (props.selectedUser && props.selectedUser.id) {
      setIsLoading(true);
      try {
        const userDoc = await UserDataService.getUser(props.selectedUser.id);
        let userDocObj = userDoc.data();
        if (userDocObj) {
          setCurrentUserData(userDocObj)
          checkUserHasParent(userDocObj)
        }
      } catch (error) {
        trackException(JSON.stringify(error))
        setIsLoading(false);
      }
    }
  }

  const removeCard = (cardObj) => {
    setSeletedCardObj(cardObj);
    setIsDeleteOpen(true);
  };

  const DeleteUser = async () => {
    deleteCard(seletedCardObj.id);
  };

  const DeleteBankAC = async () => {
    deleteBankAccount(seletedBankObj.id);
  };

  const getUserData = () => {
    if (memberHasParent && accountHolderData) {
      return accountHolderData;
    } else {
      return currentUserData;
    }
  }
  const getMemberBalance = () => {
    let userInfo = getUserData()
    return userInfo && userInfo.totalAmount && parseInt(userInfo.totalAmount) > 0 ? parseFloat(userInfo.totalAmount).toFixed(2) : '0.00'
  }

  const getMemberDrivingFeetBalance = () => {
    let userInfo = getUserData()
    return userInfo && userInfo.totalPoint && parseInt(userInfo.totalPoint) > 0 ? parseInt(userInfo.totalPoint) : 0
  }

  const getParentAccountId = () => {
    let userInfo = getUserData()
    return userInfo.id
  }

  function onAddCreditPackageClick() {
    const filteredProduct = creditPackageList.filter(product => product.id == selectedCreditPackage);
    if (filteredProduct && filteredProduct.length > 0) {
      let product = filteredProduct[0]
      let pointBalance = product.metadata?.Points
      let discount = product.metadata?.Discount
      let extraAmt = ((product.amount) / 100).toString()
      setIsLoadingAddCredit(true);
      if (product.isSubscription) {
        let str = `Credit Subscription, Credits: ${pointBalance} | Discount: ${discount}%`
        let data = JSON.stringify({
          "customerId": stripeCustomerId,
          "productId": product.id,
          "metadata": { "isPaymentFrom": "AddonSubscription", "points": pointBalance },
          "description": "Credit Package Subscription",
          "itemDesctiption": str
        });
        let config = {
          method: 'post',
          url: `${Base_Url}/stripeApi/createSubscriptionForCustomer`,
          data: data,
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${user.accessToken}`,
          }
          ,
        };
        axios.request(config)
          .then((response) => {
            setIsLoadingAddCredit(false)
            if (response) { alert("Your credit balance addition is in progress. It may take a few minutes.") }
            props.setIsOpen(false);
            props.updateGrid();
          })
          .catch((error) => {
            setIsLoadingAddCredit(false)
            showError(error)
          });
      } else {
        let str = `Credit Purchase, Credits: ${pointBalance} | Discount: ${discount}%`
        let data = JSON.stringify({
          "customerId": stripeCustomerId,
          "metadata": { "isPaymentFrom": "Addon", "points": pointBalance },
          "amount": parseInt(extraAmt),
          "isFromExtra": true,
          "description": "Credit Package",
          "itemDesctiption": str
        });
        let config = {
          method: 'post',
          url: `${Base_Url}/stripeApi/createOneTimePaymentWithProductIdV2`,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.accessToken}`,
          },
          data: data
        };
        axios.request(config)
          .then((response) => {
            setIsLoadingAddCredit(false)
            if (response) { alert("Your credit balance addition is in progress. It may take a few minutes.") }
            props.setIsOpen(false);
            props.updateGrid();
          })
          .catch((error) => {
            setIsLoadingAddCredit(false)
            showError(error)
          });
      }
    }
  }
  function showError(error) {
    if (error.response) {
      alert(`Error: ${JSON.stringify(error.response.data)}`);
    } else if (error.request) {
      alert("Error: No response from the server.");
    } else {
      alert(`Error: ${error.message}`);
    }
  }

  function onCancelSubsription() {
    setIsConfirmDialogOpen(false)
    if (selectedSub) {
      let data = JSON.stringify({
        "customerId": stripeCustomerId,
        "subscriptionId": selectedSub.id
      });
      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${Base_Url}/stripeApi/cancelStripeSubscriptionById`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${user.accessToken}`,
        },
        data: data
      };
      axios.request(config)
        .then((response) => {
          if (response) {
            alert("Cancelation is in progress. It may take a few minutes.")
          }
          props.setIsOpen(false);
          props.updateGrid();
        })
        .catch((error) => {
          console.log(error);
          showError(error)
        })
    }
  }

  function cancelSubsriptionClick(sub) {
    if (sub) {
      setSelectedSub(sub)
      setIsConfirmDialogOpen(true)
    }
  }

  function onAddMembershipClick() {
    const filteredProduct = subscriptionList.filter(product => product.id == selectedMemberships);
    if (filteredProduct && filteredProduct.length > 0) {
      let product = filteredProduct[0]
      setIsLoadingAddMembership(true)
      if (product.isSubscription) {
        let data = JSON.stringify({
          "customerId": stripeCustomerId,
          "productId": product.id,
          "metadata": { "isPaymentFrom": "Membership" },
          "description": "Membership Subscription",
          "itemDesctiption": product.name || ''
        });
        let config = {
          method: 'post',
          url: `${Base_Url}/stripeApi/createSubscriptionForCustomer`,
          data: data,
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${user.accessToken}`,
          },
        };
        axios.request(config)
          .then((response) => {
            setIsLoadingAddMembership(false)
            if (response) { alert("Membership is currently being activated. This may take a few minutes.") }
            props.setIsOpen(false);
            props.updateGrid();
          })
          .catch((error) => {
            setIsLoadingAddMembership(false)
            showError(error)
          });
      } else {
        let data = JSON.stringify({
          "customerId": stripeCustomerId,
          "productId": product.id,
          "metadata": { "isPaymentFrom": "Membership" },
          "description": "Membership Active",
        });
        let config = {
          method: 'post',
          url: `${Base_Url}/stripeApi/createOneTimePaymentWithProductIdV2`,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${user.accessToken}`,
          },
          data: data
        };
        axios.request(config)
          .then((response) => {
            setIsLoadingAddMembership(false)
            if (response) { alert("Membership is currently being activated. This may take a few minutes.") }
            props.setIsOpen(false);
            props.updateGrid();
          })
          .catch((error) => {
            setIsLoadingAddMembership(false)
            showError(error)
          });

      }
    }
  }

  useEffect(() => {
    const formfields = ["id", "memberships"];
    if (props.selectedUser) {
      setSeletedCardObj(null);
      setCardList([]);
      setBankAccount(null);
      setSubscriptionList([]);
      setCreditPackageList([]);
      getStripeSubscriptionList();
      setIsLoadingAddCredit(false);
      formfields.forEach((field) =>
        setValue(
          field,
          props.selectedUser[field]
            ? props.selectedUser[field]
            : InitialWalletState[field]
        )
      );
      getUserDetails();
      setDrivingFleetBal(0);
      setValue('memberships', [])
      // if (
      //   props.selectedUser.memberships &&
      //   props.selectedUser.memberships.length > 0
      // ) {
      //   let filteredSubscrption = subscriptionList
      //     .filter(data => props.selectedUser.memberships.includes(data.id))
      //     .map(data => data.description);
      //   setSeletedMembershipPlaceholder(filteredSubscrption.join(', '));
      // } else {
      //   setSeletedMembershipPlaceholder("");
      // }
    } else {
      setSeletedMembershipPlaceholder("");
    }
  }, [props.selectedUser]);

  return (
    <DrawerOverlay
      size={"medium"}
      position={"right"}
      open={props.isOpen}
      style={{ width: "504px" }}
      onOpenChange={(_, { open }) => props.setIsOpen(open)}
    >
      <DrawerHeader style={{
        background: "#F7F7F7",
        padding: "26px 32px"
      }}>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label="Close"
              icon={<Dismiss24Regular />}
              onClick={() => props.setIsOpen(false)}
            />
          }
        >
          {props.selectedUser ? "Payment & Memberships" : "New"}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className={styles.root}
          onReset={reset}
          id={props.selectedUser ? props.selectedUser.id : "New"}
        >
          <Label className={"side-drawer-field__label"} style={{ marginTop: 32 }}>
            <div className={"d-flex justify-space-between"}>
              <div>Stripe Customer Id:</div>
              <div style={{
                color: '#000',
                fontFamily: 'Nunito Sans',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '28px' // You can specify this directly as a string
              }}>{stripeCustomerId}</div>
            </div>
            {
              accountHolderData && (
                <Label>
                  Parent Account: {accountHolderData.firstName} {accountHolderData.lastName}
                </Label>
              )
            }
          </Label>
          <Divider className={"side-drawer-divider-gap"} />
          <Label className={"side-drawer-field__label"}>Card</Label>
          {(() => {
            // Show legacy card Sources and modern card PaymentMethods together,
            // deduped by last4, so cards saved either way appear in the list.
            const _seen = new Set();
            const mergedCards = [...(cardList || []), ...(paymentMethodCards || [])].filter((c) => {
              const key = c.last4 || c.id;
              if (_seen.has(key)) return false;
              _seen.add(key);
              return true;
            });
            return mergedCards.map((obj, index) => {
              return (
                <div>
                  <div
                    className={"bank-card-layout"}
                  >
                    <div><BankCardSVG /></div>
                    <div className={"card-number-color"}>**** **** **** {obj.last4}</div>
                    <div>
                      <div
                        className={"pointer"}
                        style={{ marginLeft: "10px" }}
                        onClick={() => {
                          removeCard(obj);
                        }}
                      >
                        <BankDeleteSVG />
                      </div>
                    </div>

                  </div>
                  {/*    )}*/}
                  {/*/>*/}

                </div>
              );
            });
          })()}
          {isLoading ? (
            <div />
          ) : (((cardList?.length || 0) + (paymentMethodCards?.length || 0)) < 2) ? (
            <>
              <div
                className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                style={{ marginTop: 32 }}
              // style={{
              //   border: "1px solid #ccc",
              //   padding: "10px",
              //   borderRadius: "5px",
              //   marginBottom: "10px",
              // }}
              >
                <CardElement />
              </div>
              <button
                  type="button"
                  className={"card-add-button pointer"}
                  onClick={getCardToken}
              >
                Add Card
              </button>
            </>
          ) : (
            <div />
          )}
          <Divider appearance="strong" className={"side-drawer-divider-gap"}></Divider>

          <div className={"d-flex"} style={{ display: "flex", alignItems: "center", marginBottom: "24px" }}>
            <div><BankSVG /></div>
            <Label className={"side-drawer-section__typo"} style={{ marginLeft: "8px" }}>Bank</Label>
          </div>
          {isLoading ? (
            <div />
          ) : (
            bankAccount &&
            bankAccount.length > 0 &&
            bankAccount.map((obj, index) => {
              return (
                <div
                  key={index}
                  style={{

                    width: "100%",
                  }}
                >
                  {/*<Controller*/}
                  {/*    name={`bank${index}`}*/}
                  {/*    control={control}*/}
                  {/*    rules={{required: false}}*/}
                  {/*    render={({field}) => (*/}
                  <div
                    style={{ width: "95%", marginBottom: "24px" }}
                    className={"bank-card-layout"}


                  >
                    {`Account Number (last4): ${obj.last4}`}
                  </div>
                  {/*    )}*/}
                  {/*/>*/}
                </div>
              );
            })
          )}

          <>
            <Label className={"side-drawer-field__label"}>Account holder name</Label>
            <Controller
              name="bank.account_holder_name"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <Input
                  className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                  {...field}
                  onChange={(e) => setAccountName(e.target.value)}
                />
              )}
            />
            <Label className={"side-drawer-field__label"}>Routing Number</Label>
            <Controller
              name="bank.routing_number"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <Input
                  className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                  {...field}
                  onChange={(e) => setRoutingNumber(e.target.value)}
                />
              )}
            />
            <Label className={"side-drawer-field__label"}>Account Number</Label>
            <Controller
              name="bank.account_number"
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <Input
                  className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                  {...field}
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              )}
            />
            <button
              className={"card-add-button pointer"}
              onClick={() => {
                generateBankToken();
              }}
            >
              Add Bank
            </button>
          </>

          <Divider appearance="strong" className={"side-drawer-divider-gap"}></Divider>
          <Label className={"side-drawer-field__label"}>Active Plan</Label>
          <SubsriptionListActive activesubscriptions={activeSubscriptionList} onCancelSubsriptionClick={(sub) => { cancelSubsriptionClick(sub) }} />

          <Divider appearance="strong" className={"side-drawer-divider-gap"}></Divider>
          <Label style={{ marginTop: '-10px' }} className={"side-drawer-field__label"}>Credit Packages (*Will charge the card on File)</Label>

          {
            creditPackageList && creditPackageList.length > 0 ?
              <Controller
                name="creditPackage"
                control={control}
                rules={{ required: false }}
                render={({ field }) => {
                  // Ensure activeSubscriptionList is an array (handles undefined/null cases)
                  const activeProductIds = Array.isArray(activeSubscriptionList)
                    ? activeSubscriptionList.map(activeSub => activeSub.productId)
                    : [];

                  // Ensure subscriptionList is an array before filtering
                  const inactiveSubscriptionList = Array.isArray(creditPackageList)
                    ? creditPackageList.filter(option => !activeProductIds.includes(option.id))
                    : [];
                  return (
                    <>
                      <Dropdown
                        multiselect={false}
                        className={"side-drawer-field-dropdown side-drawer-field__gap"}
                        onOptionSelect={(ev, data) => {
                          field.onChange(data.selectedOptions);
                          setSelectedCreditPackage(data.selectedOptions); // Update state variable
                        }}
                        selectedOptions={field.value}
                        placeholder={"Select Credit Package"}
                      >
                        {inactiveSubscriptionList.length > 0 ? (
                          inactiveSubscriptionList.map((option) => (
                            <Option key={option.id} value={option.id}>
                              {option.name}
                            </Option>
                          ))
                        ) : (
                          <Option disabled>Credit Package Not available</Option>
                        )}
                      </Dropdown>
                    </>
                  );
                }}
              /> :
              <div />
          }
          {
            creditPackageList && creditPackageList.length > 0 ?
              <div style={{ flexDirection: "row", display: "flex", justifyContent: "space-between" }}>
                {
                  isLoadingAddCredit ?
                    <Spinner label="Loading..." /> :
                    <button
                      type="button"
                      className={"card-add-button pointer"}
                      onClick={() => {
                        onAddCreditPackageClick()
                      }}
                    >+ Add
                    </button>
                }
              </div> :
              <div />
          }
          {
            isSubscriptionLoading ?
              <Spinner label="Loading..." /> :
              <div />
          }


          <Label style={{ marginTop: '18px' }} className={"side-drawer-field__label"}>Memberships (*Will charge the card on File)</Label>
          <Controller
            name="memberships"
            control={control}
            rules={{ required: false }}
            render={({ field }) => {
              // Ensure activeSubscriptionList is an array (handles undefined/null cases)
              const activeProductIds = Array.isArray(activeSubscriptionList)
                ? activeSubscriptionList.map(activeSub => activeSub.productId)
                : [];

              // Ensure subscriptionList is an array before filtering
              const inactiveSubscriptionList = Array.isArray(subscriptionList)
                ? subscriptionList.filter(option => !activeProductIds.includes(option.id))
                : [];
              return (
                <>
                  <Dropdown
                    multiselect={false}
                    className={"side-drawer-field-dropdown side-drawer-field__gap"}
                    onOptionSelect={(ev, data) => {
                      field.onChange(data.selectedOptions);
                      setSelectedMemberships(data.selectedOptions); // Update state variable
                    }}
                    selectedOptions={field.value}
                    placeholder={selectedMembershipPlaceholder || "Select New Memberships"}
                  >
                    {inactiveSubscriptionList.length > 0 ? (
                      inactiveSubscriptionList.map((option) => (
                        <Option key={option.id} value={option.id}>
                          {option.name}
                        </Option>
                      ))
                    ) : (
                      <Option disabled>No available memberships</Option>
                    )}
                  </Dropdown>
                </>
              );
            }}
          />
          {
            subscriptionList && subscriptionList.length > 0 ?
              <div style={{ flexDirection: "row", display: "flex", justifyContent: "space-between" }}>
                {
                  isLoadingAddMembership ?
                    <Spinner label="Loading..." /> :
                    <button
                      type="button"
                      className={"card-add-button pointer"}
                      onClick={() => {
                        onAddMembershipClick()
                      }}
                    >+ Active
                    </button>
                }
              </div> :
              <div />
          }

          <Divider appearance="strong" className={"side-drawer-divider-gap"}></Divider>
          <Label className={"side-drawer-field__label"}>Balance: ${getMemberBalance()}</Label>
          <Label className={"side-drawer-field__label"}>Enter Balance $</Label>
          <Controller
            name="newbalance"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Input
                className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                {...field}
                onChange={(e) => setNewbalance(e.target.value)}
              />
            )}
          />
          <Label className={"side-drawer-field__label"}>Description</Label>
          <Controller
            name="desription"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Input
                className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                {...field}
                onChange={(e) => setBalanceDesc(e.target.value)}
              />
            )}
          />
          {
            isBalanceLoader ?
              <Spinner label="Loading..." />
              :
              <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                <button
                  type="button"
                  className={"card-add-button pointer"}
                  onClick={() => {
                    onAddBalanceClick()
                  }}
                >
                  + Add Balance
                </button>
                <button
                  type="button"
                  className={"card-add-button pointer"}
                  onClick={() => {
                    onSubtractBalanceClick()
                  }}
                >
                  - Subtract Balance
                </button>
              </div>
          }

          <Divider appearance="strong" className={"side-drawer-divider-gap"}></Divider>
          <Label className={"side-drawer-field__label"}>Driving Fleet Credit: {getUSDFromPoint(getMemberDrivingFeetBalance())} USD {`(${getMemberDrivingFeetBalance()} Points)`}</Label>
          <Label className={"side-drawer-field__label"}>Enter Driving Fleet Balance $</Label>
          <Controller
            name="newbalance"
            control={control}
            rules={{ required: false }}
            render={({ field }) => (
              <Input
                className={"side-drawer-field  side-drawer-field__gap side-drawer-field__gap"}
                {...field}
                onChange={(e) => setDrivingFleetBal(e.target.value)}
              />
            )}
          />
          {
            isBalanceLoader ?
              <Spinner label="Loading..." />
              :
              <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                <button
                  type="button"
                  className={"card-add-button pointer"}
                  onClick={() => {
                    onAddDrivingFleetBalanceClick()
                  }}
                >
                  + Add Credit
                </button>
                <button
                  type="button"
                  className={"card-add-button pointer"}
                  onClick={() => {
                    onSubtractDrivingFleetBalanceClick()
                  }}
                >
                  - Subtract Credit
                </button>
              </div>
          }


          <div className="btnUpdateActions">
            {/* <button
              appearance="primary"
              type="submit"
              className="wallet-Update-button"

            >
              {"Update"}
            </button> */}
            {/* <Button className="btnCancel" icon={<CalendarCancelFilled />}
                            onClick={() => props.setIsOpen(false)}>Cancel</Button> */}
          </div>

          <DeleteEventDialog
            isDeleteDialogOpen={isDeleteOpen}
            setIsDeleteDialogOpen={setIsDeleteOpen}
            DeleteEvent={DeleteUser}
            text={"Card"}
          />
          <DeleteEventDialog
            isDeleteDialogOpen={isDeleteBankOpen}
            setIsDeleteDialogOpen={setIsDeleteBankOpen}
            DeleteEvent={DeleteBankAC}
            text={"Bank account"}
          />
        </form>
      </DrawerBody>

      <ConfirmationDialog
        isConfirmDialogOpen={isConfirmDialogOpen}
        setIsDeleteDialogOpen={setIsConfirmDialogOpen}
        YesEvent={() => { onCancelSubsription() }}
        text={"Confirm"}
        msg={"Are you sure you want to cancel this subscription?"}
      />
    </DrawerOverlay>
  );
}

export default UserWalletForm;

const getUSDFromPoint = (point) => {
  return parseFloat(point * 20)
}
const getPointFromUSD = (balance) => {
  return parseFloat(balance / 20)
}